var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.8 53.7",
    style: {
      enableBackground: "new 0 0 42.8 53.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#F96277;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#6363F7;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{fill:#FA9A63;}\n\t.st5{fill:#FADC63;}\n\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{fill:url(#);stroke:#000000;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.4,21.5c2.3-1.5,6.6,1.1,9.5,5.7s3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,17.5c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 13,
    y1: 42.7,
    x2: 23.2,
    y2: 32.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.7,48.2c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.7,48.2c-2.6,4.8-8.6,6.6-13.4,4c-4.8-2.6-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.2,9.5c-1.3,2.4-6.3,2.2-11.1-0.4s-7.7-6.7-6.4-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.2,9.5c-2.6,4.8-8.6,6.6-13.4,4s-6.6-8.6-4-13.4"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 3.2,
    cy: 43.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 25.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.1,
    cy: 10.6,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.9,20.1c-2.6,0-4.8-2.1-4.8-4.8c0-2.1,1.7-3.8,3.8-3.8c1.7,0,3.1,1.4,3.1,3.1c0,1.4-1.1,2.5-2.5,2.5 c-1.1,0-2-0.9-2-2c0-0.9,0.7-1.6,1.6-1.6c0.7,0,1.3,0.6,1.3,1.3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern3);
export default __webpack_public_path__ + "static/media/Pattern3.e916941fa423b6d77022e67d211cd63d.svg";
export { ForwardRef as ReactComponent };